import useMixingTokoText from 'hooks/business/useMixingTokoText';
import Page, { PageRoute } from '../components/Page';
import useEntryTrack from '../hooks/useEntryTrack';
import { getRouteAccess } from '../Scenario/config';
import { ReactComponent as OrderSvg } from '../assets/order.svg';
import Icon from '@ant-design/icons/lib/components/Icon';

import Scenario from '../Scenario/Scenario';

export const orderRouteAccess = getRouteAccess('配置催单催付任务');

export const route: PageRoute = {
  path: 'order',
  i18nHelmetTitle: 'marketing.催下单',
  menu: {
    label: '催下单',
    icon: <Icon component={OrderSvg} />,
  },
  element: <Order />,
  access: orderRouteAccess,
};

function Order() {
  useEntryTrack('aide/order');
  const {
    orderReminderTitle: { i18nKey },
  } = useMixingTokoText();

  return (
    <Page
      route={{
        ...route,
        element: <Scenario scenarioType="ORDER_REMINDER" />,
        i18nHelmetTitle: i18nKey as any,
      }}
    />
  );
}

export default Order;
